import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class ActionLogService {

  constructor(private http: HttpClient) { }

  search(criteria: any, from: number = 0, limit: number = 1000) {
    return this.http.post<any>(environment.app.apiUrl + `actionlog/search/${from}/${limit}`, criteria, { context: SharedService.NO_LOADING_BAR }).toPromise();
  }
  log(actionLog: any) {
    var params = JSON.parse(JSON.stringify(actionLog));
    return this.http.get<any>(environment.app.apiUrl + `actionlog/log/`, { params, context: SharedService.NO_LOADING_BAR }).toPromise();
  }

}
